import { motion } from "framer-motion";
import { MdErrorOutline } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import axiosToken from "../../api/axiosClient";
import { toast } from "react-toastify";
import { useState } from "react";

const AccountNotActivated = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const userEmail = location.state?.email;
  const [loading, setLoading] = useState(false);

  const onResend = async () => {
    try {
      setLoading(true);
      const response = await axiosToken.post(
        "/user/resendEmailVerificationCode",
        { email: userEmail }
      );
      toast.success(
        "E-mail d'activation renvoyé. Veuillez vérifier votre boîte de réception.",
        {
          position: "bottom-left",
        }
      );

      // Gérer la réponse, par exemple stocker le token
      localStorage.setItem("authToken", response.data.token);
      localStorage.setItem("email", userEmail);

      setLoading(false);

      setTimeout(() => {
        navigate(`/register-2/login`); // rediriger vers la page de vérification ou autre
      }, 1000);
    } catch (err) {
      console.error(
        "Erreur lors de la tentative de renvoi de l'e-mail d'activation. Erreur: ",
        err
      );
      toast.error(
        err?.response?.data?.error ||
          "Erreur lors de la tentative de renvoi de l'e-mail d'activation.",
        {
          position: "bottom-left",
        }
      );
      setLoading(false);
    }
  };

  document.title = "Compte inatif || Barberlys";

  return (
    <motion.div
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.4 }}
      className="min-h-screen flex items-center justify-center px-4"
    >
      <div className="shadow-xl p-8 max-w-md w-full text-center space-y-6">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: [0.8, 1.2, 1] }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          className="flex justify-center"
        >
          <MdErrorOutline
            size={64}
            className="text-yellow-400 drop-shadow-lg"
          />
        </motion.div>

        <h2 className="text-xl font-semibold">Compte non activé</h2>
        <p className="text-gray-500 text-sm">
          L'adresse <span className="font-medium text-white">{userEmail}</span>{" "}
          n'a pas encore été vérifiée. Veuillez consulter votre boîte mail pour
          activer votre compte.
        </p>

        <div className="space-y-4">
          {/* Button retour  */}
          <button
            type="button"
            onClick={() => {
              navigate(-1);
            }}
            className="bg-black text-white py-2 px-4 shadow hover:bg-gray-500 font-semibold transition-all"
          >
            Retour
          </button>

          <button
            disabled={loading}
            type="button"
            onClick={onResend}
            className=" w-full bg-secondary-300 hover:bg-secondary-400 hover:scale-105 text-white py-2 px-4 font-semibold transition-all"
          >
            {loading ? (
              <div className="flex flex-row justify-center items-center gap-2">
                <div className="animate-spin rounded-full h-4 w-4 border-t-4 border-b-4 border-white" />
                <span>Envoi...</span>
              </div>
            ) : (
              "Renvoyer l'e-mail d'activation"
            )}
          </button>
        </div>
      </div>
    </motion.div>
  );
};

export default AccountNotActivated;
